import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip, Popover } from "react-bootstrap";
import {
  renderAgeOfWorkOrder,
  checkIsOverdueWorkOrder,
  toggleScrollBody,
} from "../../helper/unit-helper";
import RFSInfo from "Work-Orders/Components/RFSInfo";
import { Dropdown } from "components/Dropdown/Dropdown";
import { AppSettings } from "../../constants";
import * as RFSActionType from "../../Request-Services/constants";
import * as WorkOrderActionType from "Work-Orders/constants";
import * as PunchListActionTypes from "../constants";
import TableList from "components/TableList";
import SignoffMultiplePopup from "../../Request-Services/Components/SignoffMultiplePopup";
import SendMultipleWorkOrderPopup from "../Components/SendMultipleWorkOrderPopup";
import { CheckBox } from "components/checkboxes/check-box";
import { Popup } from "components/Popup/popup";
import { CheckBoxSingle } from "components/checkboxes/check-box-single";
import Translate from "components/translate";
import AlertRequestTypeNotAvailable from "../Components/alert-request-type-not-available";
import { exportBlueTapeReport, sendBlueTapeEmail } from "../api";
import TagsInput from "../../components/tag-input";
import * as NotifyActionType from "../../Notification/constants";

const defaultParams = {
  defaultSortName: "refNo",
  defaultSortOrder: "descending",
  sizePerPage: 100,
};

const PUNCH_ITEM_STATUS_VALUE =
  AppSettings.clientTypeValue === "Builder"
    ? AppSettings.PUNCH_ITEM_STATUS_VALUE
    : AppSettings.PUNCH_ITEM_STATUS_VALUE.filter(
        (x) => x.key !== 2 && x.key !== 6,
      );

// let defaultCheckedValues = [1, 2, 6]; // Open, Pending, Reuqest

let defaultCheckedValues =
  AppSettings.clientTypeValue === "Builder"
    ? [1, 2, 6] // Open, Pending, Reuqest
    : PUNCH_ITEM_STATUS_VALUE.map((item) => item.key);

class ManagePunchListItems extends Component {
  static propTypes = {
    history: PropTypes.object,
    ManageWorkOrderTypes: PropTypes.object,
    dispatch: PropTypes.func,
    match: PropTypes.object,
    location: PropTypes.object,
    PunchListProfile: PropTypes.object,
    rfsAction: PropTypes.object,
  };
  constructor(props) {
    super(props);

    let punchListRefNo = null;

    if (props.match.params.punchListRefNo) {
      punchListRefNo = props.match.params.punchListRefNo;
    }

    const queryParams = new URLSearchParams(this.props.location.search);
    const clientUrl = queryParams.get("clientUrl");

    const tradeId = queryParams.get("tradeId");
    const subcontractorId = queryParams.get("subcontractor");

    let modeClose = false;
    if (queryParams.get("mode") && queryParams.get("mode") === "close") {
      modeClose = true;
    }

    const headerOptions = [
      {
        value: 0,
        text: "Bulk actions",
      },
      {
        value: 2,
        text: "Send multiple WOs",
      },
      {
        value: 1,
        text: "Close multiple WOs",
      },
    ];

    this.state = {
      rfsStatus: AppSettings.RFS_STATUS_VALUE,
      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder, // default sort order,
      currentPage: 1,
      sizePerPage: defaultParams.sizePerPage,
      punchListRefNo,
      clientUrl,
      subcontractorId,
      tradeId,
      modeClose: modeClose,
      headerOptions: headerOptions,
      headerAction: modeClose ? headerOptions[2] : headerOptions[0],
      isDisplaySignoffMultiplePopup: false,
      isDisplaySendMultiplePopup: false,
      data: [],
      openAlertModal: false,
      column: [
        {
          field: "refNo",
          header: "WO#",
          hidden: false,
          isKey: true,
          sort: false,
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderWOID.bind(this),
          widthStyle: "name",
        },
        {
          field: "WOInformation.Trade",
          header: "Trade",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderTrade.bind(this),
          widthStyle: "name",
        },
        {
          field: "WOInformation.SubcontractorOfProject",
          header: "Assigned to",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderAssigned.bind(this),
          widthStyle: "name",
        },
        {
          field: "Summary",
          header: "Summary",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderSummary.bind(this),
          widthStyle: "description-punchlist",
        },
        {
          field: "description",
          header: "Description",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderDescription.bind(this),
          widthStyle: "description-punchlist",
        },
        {
          field: "WOInformation.StatusValue",
          header: "Status",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderStatus.bind(this),
          widthStyle: "name",
        },
        {
          field: "WOInformation.dueDate",
          header: "Age of assignment",
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderAge.bind(this),
          widthStyle: "name",
        },
      ],
      refNoCheckList: {},
      isSetDefaultCheckList: false,
      checkedValues: defaultCheckedValues,
      refNoSendCheckList: {},
      trade: null,
      assignee: null,
      lotStatus: false,
      showEmailInputBox: false,
      recipientEmail: [],
      emailSuggestions: [],
      inputProps: { placeholder: "Type email address" },
    };

    this.defaultNumOfColumn = this.state.column.length;
  }

  componentDidMount() {
    this.fetchPunchListDetail();
    this.fetchLotPaidFeature();
    if (this.state.modeClose) {
      this.onApplyAction(this.state.headerAction.value, this.props);
    }

    const self = this;
    window.addEventListener("click", (e) => {
      if (
        document.getElementById("s1-popup") &&
        document.getElementById("s1-popup").contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById("popup-button") &&
          document.getElementById("popup-button").contains(e.target)
        ) {
          // clicked in box
        } else {
          if (self.state.isShowPopup) {
            self.setState({ isShowPopup: false });
          }
        }
      }
    });

    this.updatePredicate();
    window.addEventListener("resize", this.updatePredicate);
  }

  componentWillReceiveProps(nextProps) {
    const { PunchListProfile } = nextProps;

    if (
      PunchListProfile &&
      PunchListProfile.workOrders &&
      PunchListProfile.workOrders.items
    ) {
      this.onFilterPunchItem(PunchListProfile.workOrders.items);
    }

    if (this.state.modeClose && !this.state.isSetDefaultCheckList) {
      this.handleCheckBoxList(nextProps);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePredicate);
  }

  updatePredicate = () => {
    this.setState({ isMobile: window.innerWidth < 768 });
  };

  fetchPunchListDetail() {
    if (AppSettings.clientTypeValue === "Subcontractor") {
      this.props.dispatch({
        type: PunchListActionTypes.GET_SUBCONTRACTOR_PUNCH_LIST_DETAIL_ASYNC,
        params: {
          refNo: this.state.punchListRefNo,
          host: this.state.clientUrl,
          subcontractorId: this.state.subcontractorId,
          tradeId: this.state.tradeId,
        },
      });
    } else {
      this.props.dispatch({
        type: PunchListActionTypes.GET_PUNCH_LIST_DETAIL_ASYNC,
        params: { refNo: this.state.punchListRefNo },
      });
    }
  }

  fetchLotPaidFeature() {
    this.props.dispatch({
      type: PunchListActionTypes.GET_LOT_PAID_FEATURE,
      callback: (data, success) => {
        if (success && data.data && data.data.length > 0) {
          this.setState({ lotStatus: data.data[0].lotStatus });
        }
      },
    });
  }

  binding(params) {
    this.props.dispatch({
      type: RFSActionType.GET_LIST_WORK_ORDER_BY_RFSID_ASYNC,
      params: params,
    });
  }

  objToParams(obj) {
    return {
      rfsId: this.state.punchListRefNo,
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      status: obj.status,
      skip: obj.skip - 1,
      take: obj.take,
    };
  }

  onTableBinding(configTable) {
    var params = this.objToParams(this.props.ManageWorkOrderTypes.params);

    this.binding({
      ...params,
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip - 1,
      take: configTable.page.take,
    });
  }

  onChangeStatus(event) {
    this.setState((prevState) => ({
      RFSInforamation: {
        ...prevState.RFSInforamation,
        status: event.value,
      },
    }));
  }

  getReportFilename = (headers, fallbackName) => {
    const disposition =
      (headers &&
        (headers["content-disposition"] || headers["Content-Disposition"])) ||
      "";
    if (disposition) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);
      if (matches !== null && matches[1]) {
        return matches[1].replace(/['"]/g, "");
      }
    }
    return fallbackName;
  };

  downloadBlob = (blob, filename) => {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
      return;
    }

    const link = document.createElement("a");
    const downloadUrl = window.URL.createObjectURL(blob);
    link.href = downloadUrl;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => {
      window.URL.revokeObjectURL(downloadUrl);
    }, 100);
  };

  onPrintReport = () => {
    const { PunchListProfile } = this.props;
    const rfsRefNo =
      Number(this.state.punchListRefNo) ||
      Number(get(PunchListProfile, "refNo"));
    const items =
      (this.state.data && this.state.data.length
        ? this.state.data
        : get(PunchListProfile, "workOrders.items", [])) || [];
    const woRefNos = items.map((item) => item.refNo).filter((refNo) => refNo);

    if (!rfsRefNo || woRefNos.length === 0) {
      return;
    }

    exportBlueTapeReport({ rfsRefNo, woRefNos }).then((result) => {
      if (result && result.statusCode === 200) {
        const filename = this.getReportFilename(result.headers, "report.pdf");
        const blob = new Blob([result.data], { type: "application/pdf" });
        this.downloadBlob(blob, filename);
      }
    });
  };

  onClickOnEmailButton = () => {
    this.setState({ showEmailInputBox: true }, () => {
      if (
        !this.state.emailSuggestions ||
        this.state.emailSuggestions.length === 0
      ) {
        this.fetchAllUserEmailsForSuggestions();
      }
    });
  };

  onCloseEmailBox = () => {
    this.setState({ showEmailInputBox: false, recipientEmail: [] });
  };

  fetchAllUserEmailsForSuggestions = () => {
    this.props.dispatch({
      type: WorkOrderActionType.GET_ALL_USER_EMAILS,
      params: {},
      callback: (res) => {
        this.setState({
          emailSuggestions: Array.isArray(res)
            ? res.filter((x) => typeof x === "string")
            : [],
        });
      },
    });
  };

  handleEmailChange = (tags) => {
    let tagsValid = [];
    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;
    tags.map((tag) => {
      if (emailPattern.test(tag)) {
        tagsValid.push(tag);
      }
    });

    this.setState({
      recipientEmail: tagsValid,
    });
  };

  onClickSendInEmailBox = () => {
    const { PunchListProfile } = this.props;
    const rfsRefNo =
      String(this.state.punchListRefNo) ||
      String(get(PunchListProfile, "refNo"));
    const items =
      (this.state.data && this.state.data.length
        ? this.state.data
        : get(PunchListProfile, "workOrders.items", [])) || [];
    const woRefNos = items.map((item) => item.refNo).filter((refNo) => refNo);

    if (!rfsRefNo || woRefNos.length === 0) {
      return;
    }

    const payload = {
      rfsRefNo,
      woRefNos,
      Emails: this.state.recipientEmail,
    };

    sendBlueTapeEmail(payload).then((result) => {
      if (result && (result.data === true || result.data === "true")) {
        this.props.dispatch({
          type: NotifyActionType.NOTIFY_SUCCESS,
          data: "Email sent successfully",
        });
        this.setState({ showEmailInputBox: false, recipientEmail: [] });
      } else {
        this.props.dispatch({
          type: NotifyActionType.NOTIFY_ERROR,
          data: "Failed to send email",
        });
      }
    });
  };

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage,
      },
      () => {
        this.props.dispatch({
          type: RFSActionType.GET_LIST_WORK_ORDER_BY_RFSID_ASYNC,
          params: {
            rfsId: this.state.punchListRefNo,
            sortField: params.defaultSortName,
            sortOrder: params.defaultSortOrder,
            skip: params.currentPage - 1,
            take: params.sizePerPage,
          },
        });
      },
    );
  }

  customRenderWO = (field, row) => {
    let value = get(row, field);
    return value || "";
  };

  onClickWOID = (item) => (e) => {
    e.preventDefault();
    this.props.dispatch({
      type: WorkOrderActionType.GET_WORK_ORDER_DETAIL_SUCCESS,
      data: {
        workOrder: item,
        requestDetail: this.props.PunchListProfile,
      },
    });
    this.props.history.push(
      `/punch-lists/${this.state.punchListRefNo}/punch-list-item/${item.refNo}`,
    );
  };

  onNewWorkOrder = () => {
    this.props.history.push(`/punch-lists/${this.state.punchListRefNo}/add`);
  };

  handleCheckBoxList = () => {
    if (this.state.data.length) {
      const { data } = this.state;
      const checkedList = {};
      for (let i = 0; i < data.length; i++) {
        if (AppSettings.clientTypeValue === "Homeowner") {
          if (data[i].status === 4) {
            checkedList[data[i].refNo] = true;
          }
        } else {
          if (data[i].status === 1 || data[i].status === 4) {
            checkedList[data[i].refNo] = true;
          }
        }
      }
      this.setState({
        refNoCheckList: checkedList,
        isSetDefaultCheckList: true,
      });
    }
  };

  handleCheckBoxListSend = () => {
    if (this.state.data.length) {
      const { data } = this.state;
      const checkedList = {};
      for (let i = 0; i < data.length; i++) {
        if (data[i].status === 2) {
          checkedList[data[i].refNo] = true;
        }
      }
      this.setState({
        refNoSendCheckList: checkedList,
      });
    }
  };

  onActionDefault = () => {
    const newColumnState = [...this.state.column];
    newColumnState.shift();
    this.setState({
      column: newColumnState,
    });
  };

  onActionCloseMultiple = (props) => {
    const { column } = this.state;

    const checkboxColumn = {
      field: "",
      header: "",
      hidden: false,
      isKey: false,
      sort: false,
      dataAlign: "left",
      headerAlign: "left",
      columnClassName: "td-width-50-px",
      customRender: this.customRenderCheckboxColumnClose.bind(this),
    };
    const newColumnState = [...column];

    if (column.length > this.defaultNumOfColumn) {
      newColumnState.shift();
    }

    newColumnState.unshift(checkboxColumn);
    this.setState({
      column: newColumnState,
    });

    this.handleCheckBoxList(props);
  };

  onActionSendMultiple = (props) => {
    const { column } = this.state;

    const checkboxColumn = {
      field: "",
      header: "",
      hidden: false,
      isKey: false,
      sort: false,
      dataAlign: "left",
      headerAlign: "left",
      columnClassName: "td-width-50-px",
      customRender: this.customRenderCheckboxColumnSend.bind(this),
    };

    const newColumnState = [...column];

    if (column.length > this.defaultNumOfColumn) {
      newColumnState.shift();
    }

    newColumnState.unshift(checkboxColumn);
    this.setState({
      column: newColumnState,
    });

    this.handleCheckBoxListSend(props);
  };

  onApplyAction = (value, props) => {
    switch (value) {
      case 0:
        this.onActionDefault();
        break;
      case 1:
        this.onActionCloseMultiple(props);
        break;
      case 2:
        this.onActionSendMultiple(props);
        break;
      default:
        break;
    }
  };

  onChangeHeaderAction = (event) => {
    this.setState({
      headerAction: event.value,
    });
    this.onApplyAction(event.value.value, this.props);
  };

  onChecked = (refNo) => {
    if (!this.state.refNoCheckList[refNo]) {
      this.setState({
        refNoCheckList: {
          ...this.state.refNoCheckList,
          [refNo]: !this.state.refNoCheckList[refNo],
        },
      });
    } else {
      let newCheckList = { ...this.state.refNoCheckList };
      delete newCheckList[refNo];
      this.setState({
        refNoCheckList: newCheckList,
      });
    }
  };

  onCheckedSendAction = (refNo) => {
    const { refNoSendCheckList } = this.state;
    if (!refNoSendCheckList[refNo]) {
      this.setState({
        refNoSendCheckList: {
          ...refNoSendCheckList,
          [refNo]: !refNoSendCheckList[refNo],
        },
      });
    } else {
      let newCheckList = { ...refNoSendCheckList };
      delete newCheckList[refNo];
      this.setState({
        refNoSendCheckList: newCheckList,
      });
    }
  };

  toolTip() {
    return (
      <Tooltip
        id="sign_off_multiple_work_order_tooltip"
        className="in tooltip-siteone"
      >
        <span>
          Only work orders with{" "}
          {AppSettings.clientTypeValue === "Homeowner"
            ? "Resolved"
            : "Open/Resolved"}{" "}
          status can be selected.
        </span>
      </Tooltip>
    );
  }

  toolTipDisabledSend() {
    return (
      <Tooltip
        id="sign_off_multiple_work_order_tooltip"
        className="in tooltip-siteone"
      >
        <span>Only work orders with Pending status can be selected.</span>
      </Tooltip>
    );
  }

  popoverRight() {
    return (
      <Popover id="popover-positioned-right" className="sign-off-error-popover">
        <span>At least one work order must be selected.</span>
      </Popover>
    );
  }

  onClickGoSignoffMultiplePopup = () => {
    toggleScrollBody(this.state.isDisplaySignoffMultiplePopup);
    this.setState({
      isDisplaySignoffMultiplePopup: !this.state.isDisplaySignoffMultiplePopup,
    });
  };

  onClickGoSendMultiplePopup = () => {
    toggleScrollBody(this.state.isDisplaySendMultiplePopup);
    this.setState({
      isDisplaySendMultiplePopup: !this.state.isDisplaySendMultiplePopup,
    });
  };

  onSaveSignoffMultiple = (lastClosedDate, closeNote) => {
    const { refNoCheckList } = this.state;
    let workOrderIds = [];
    Object.keys(refNoCheckList).forEach((key) => {
      if (refNoCheckList[key]) {
        workOrderIds.push(parseInt(key));
      }
    });
    this.props.dispatch({
      type: RFSActionType.SIGNOFF_MULTIPLE_WORK_ORDER_ASYNC,
      params: {
        refNo: this.state.punchListRefNo,
        param: {
          workOrderIds,
          lastClosedDate,
          closeNote: closeNote || "",
        },
      },
      callback: () => {
        this.setState({
          isDisplaySignoffMultiplePopup: false,
          headerAction: {
            value: 0,
            text: "Bulk actions",
          },
        });

        toggleScrollBody(true);

        const newColumnState = [...this.state.column];
        newColumnState.shift();
        this.setState({
          column: newColumnState,
        });
        this.fetchPunchListDetail();
      },
    });
  };

  onGetBuilderProfileSignOffMultiple = (
    workOrderIds,
    lastClosedDate,
    closeNote,
  ) => {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      params: {
        lotId: PunchListProfile.RFSProfile.lot.id,
      },
      callbackGetBuilderProfile: (builderProfile) => {
        this.onSignOffMultiHomeownerWorkOrder(
          builderProfile,
          workOrderIds,
          lastClosedDate,
          closeNote,
        );
      },
    });
  };

  onSignOffMultiHomeownerWorkOrder = (
    builderProfile,
    workOrderIds,
    lastClosedDate,
    closeNote,
  ) => {
    /**
     * BuilderProfile get from homeowner portal by server
     */
    this.props.dispatch({
      type: RFSActionType.SIGNOFF_MULTIPLE_HOMEOWNER_WORK_ORDER_ASYNC,
      params: {
        builderHost: builderProfile.builderHost,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken,
        },
        param: {
          refNo: this.state.punchListRefNo,
          data: {
            workOrderIds,
            lastClosedDate,
            closeNote: closeNote || "",
          },
        },
      },
      callback: () => {
        this.setState({
          isDisplaySignoffMultiplePopup: false,
          headerAction: {
            value: 0,
            text: "Bulk actions",
          },
        });
        const newColumnState = [...this.state.column];
        newColumnState.shift();
        this.setState({
          column: newColumnState,
        });
        this.fetchPunchListDetail();
      },
    });
  };

  onSaveSendMultiple = () => {
    const { refNoSendCheckList, punchListRefNo } = this.state;

    let punchItemRefNos = [];

    Object.keys(refNoSendCheckList).forEach((key) => {
      if (refNoSendCheckList[key]) {
        punchItemRefNos.push(parseInt(key));
      }
    });

    this.props.dispatch({
      type: PunchListActionTypes.SEND_MULTIPLE_PUNCH_ITEM_ASYNC,
      params: {
        punchListRefNo,
        data: {
          refNos: punchItemRefNos,
        },
      },
      callback: () => {
        this.setState({
          isDisplaySendMultiplePopup: false,
          headerAction: {
            value: 0,
            text: "Bulk actions",
          },
        });

        toggleScrollBody(true);

        const newColumnState = [...this.state.column];
        newColumnState.shift();
        this.setState({
          column: newColumnState,
        });
        this.fetchPunchListDetail();
      },
    });
  };

  onEnter(e) {
    if (e.key === "Enter") {
      this.onSearch(e);
    }
  }

  onSearch() {
    const { PunchListProfile } = this.props;
    if (PunchListProfile) {
      this.onFilterPunchItem(PunchListProfile.workOrders.items);
    }
  }

  onTogglePopupFilter = () => {
    this.setState({
      isShowPopup: !this.state.isShowPopup,
    });
  };

  handleChange = (e, value) => {
    if (this.state.checkedValues.includes(value)) {
      this.setState(
        {
          checkedValues: [
            ...this.state.checkedValues.filter((item) => item !== value),
          ],
        },
        () => {
          this.onCheckedFilterStatus(e, this.state.checkedValues);
        },
      );
    } else {
      this.setState(
        {
          checkedValues: [...this.state.checkedValues, value],
        },
        () => {
          this.onCheckedFilterStatus(e, this.state.checkedValues);
        },
      );
    }
  };

  onCheckedFilterStatus = () => {
    const { PunchListProfile } = this.props;
    if (PunchListProfile) {
      this.onFilterPunchItem(PunchListProfile.workOrders.items);
    }
  };

  customRenderCheckboxColumnClose(item) {
    const { status, refNo } = item;
    const disabled =
      (AppSettings.clientTypeValue === "Homeowner" && status !== 4) ||
      (AppSettings.clientTypeValue !== "Homeowner" &&
        status !== 1 &&
        status !== 4);
    if (disabled) {
      return (
        <OverlayTrigger placement="top" overlay={this.toolTip()}>
          <div>
            <CheckBoxSingle
              checked={
                this.state.refNoCheckList[refNo] !== null &&
                this.state.refNoCheckList[refNo] === true
              }
              ref={(c) => {
                this.check = c;
              }}
              name="checkToSignoff"
              disabled={disabled}
              className="checkbox-default"
              onChecked={() => this.onChecked(refNo)}
              style={{ marginTop: -7 }}
            />
          </div>
        </OverlayTrigger>
      );
    } else {
      return (
        <CheckBoxSingle
          checked={
            this.state.refNoCheckList[refNo] !== null &&
            this.state.refNoCheckList[refNo] === true
          }
          ref={(c) => {
            this.check = c;
          }}
          name="checkToSignoff"
          disabled={disabled}
          className="checkbox-default"
          onChecked={() => this.onChecked(refNo)}
          style={{ marginTop: -7 }}
        />
      );
    }
  }

  customRenderCheckboxColumnSend(item) {
    const { status, refNo } = item;
    const { refNoSendCheckList } = this.state;
    const disabled = status !== 2; //status !== pending => disabled checkbox
    if (disabled) {
      return (
        <OverlayTrigger placement="top" overlay={this.toolTipDisabledSend()}>
          <div>
            <CheckBoxSingle
              checked={
                refNoSendCheckList[refNo] !== null &&
                refNoSendCheckList[refNo] === true
              }
              ref={(c) => {
                this.check = c;
              }}
              name="checkToSend"
              disabled={disabled}
              className="checkbox-default"
              onChecked={() => this.onCheckedSendAction(refNo)}
              style={{ marginTop: -7 }}
            />
          </div>
        </OverlayTrigger>
      );
    } else {
      return (
        <CheckBoxSingle
          checked={
            refNoSendCheckList[refNo] !== null &&
            refNoSendCheckList[refNo] === true
          }
          ref={(c) => {
            this.check = c;
          }}
          name="checkToSend"
          disabled={disabled}
          className="checkbox-default"
          onChecked={() => this.onCheckedSendAction(refNo)}
          style={{ marginTop: -7 }}
        />
      );
    }
  }

  customRenderWOID(item) {
    // if (AppSettings.clientTypeValue === 'Subcontractor') {
    //   return <span>{item.refNo}</span>;
    // }
    return (
      <span>
        <Link
          to={`/punch-lists/${this.state.punchListRefNo}/punch-list-item/${item.refNo}`}
          onClick={this.onClickWOID(item)}
        >
          {item.refNo}
        </Link>
      </span>
    );
  }

  customRenderDescription(item) {
    return (
      <div style={{ whiteSpace: "break-spaces" }}>
        {item ? item.description : "-"}
      </div>
    );
  }

  customRenderTrade(item) {
    if (item) {
      return <span>{item.trade ? item.trade.name : "-"}</span>;
    }
    return null;
  }

  customRenderAssigned(item) {
    if (item) {
      if (item.subcontractorProfile) {
        return <span>{item.subcontractorProfile.companyName}</span>;
      }
      if (item.assignedUser) {
        return <span>{item.assignedUser.displayName}</span>;
      }
      return "-";
    }
    return "-";
  }

  customRenderSummary(item) {
    return (
      <div style={{ whiteSpace: "break-spaces" }}>
        {item ? item.title : "-"}
      </div>
    );
  }

  customRenderStatus(item) {
    if (item.status === 0) {
      return <span>Awaiting review</span>;
    } else if (item.status === 6) {
      return <span>Requested to reopen</span>;
    } else {
      return <span>{item.statusValue}</span>;
    }
  }

  customRenderAge(item) {
    return renderAgeOfWorkOrder(item);
  }

  onToggleReviewRFS = () => {
    this.setState({ isReviewRFS: !this.state.isReviewRFS });
  };

  getTradeOptions = () => {
    const { PunchListProfile } = this.props;

    let trades = [];

    if (PunchListProfile && PunchListProfile.workOrders) {
      const { items } = PunchListProfile.workOrders;

      let tradeIds = [];

      items.map((item) => {
        if (item.trade && tradeIds.indexOf(item.trade.id) === -1) {
          const { trade } = item;
          trades.push({ value: trade.id, text: trade.name });
          tradeIds.push(trade.id);
        }
      });
    }

    return trades;
  };

  onChangeTradeFilter = (e) => {
    this.setState(
      {
        trade: e.value,
      },
      () => {
        const { PunchListProfile } = this.props;
        if (PunchListProfile) {
          this.onFilterPunchItem(PunchListProfile.workOrders.items);
        }
      },
    );
  };

  getAssigneeOptions = () => {
    const { PunchListProfile } = this.props;

    let assignees = [];

    if (PunchListProfile && PunchListProfile.workOrders) {
      const { items } = PunchListProfile.workOrders;

      let assigneeIds = [];

      items.map((item) => {
        if (
          item.assignedUser &&
          assigneeIds.indexOf(item.assignedUser.id) === -1
        ) {
          const { assignedUser } = item;
          assignees.push({
            value: assignedUser.id,
            text: assignedUser.displayName,
          });
          assigneeIds.push(assignedUser.id);
        } else if (
          item.subcontractorProfile &&
          assigneeIds.indexOf(item.subcontractorProfile.subcontractorId) === -1
        ) {
          const { subcontractorProfile } = item;
          assignees.push({
            value: subcontractorProfile.subcontractorId,
            text: subcontractorProfile.companyName,
          });
          assigneeIds.push(subcontractorProfile.subcontractorId);
        }
      });
    }

    return assignees;
  };

  onChangeAssigneeFilter = (e) => {
    this.setState(
      {
        assignee: e.value,
      },
      () => {
        const { PunchListProfile } = this.props;
        if (PunchListProfile) {
          this.onFilterPunchItem(PunchListProfile.workOrders.items);
        }
      },
    );
  };

  filterAssignee = (item) => {
    const { assignee } = this.state;
    const condition =
      (item.assignedUser && item.assignedUser.id === assignee.value) ||
      (item.subcontractorProfile &&
        item.subcontractorProfile.subcontractorId === assignee.value);

    return condition;
  };

  onFilterPunchItem = (paramItems) => {
    let items = [...paramItems];
    const { trade, assignee, checkedValues } = this.state;
    const search = this.search ? this.search.value : "";

    if (trade) {
      items = items.filter((item) => item.trade.id === trade.value);
    }

    if (assignee) {
      items = items.filter(this.filterAssignee);
    }

    items = items.filter((item) => item.title.includes(search));

    items = items.filter((item) => checkedValues.includes(item.status));

    this.setState({
      data: items,
    });
  };

  renderPunchListInfo = () => {
    return (
      <RFSInfo
        RFSInformation={this.props.PunchListProfile}
        onToggleReviewRFS={this.onToggleReviewRFS}
        location={this.props.location}
        history={this.props.history}
        mode="punchList"
        displayStatus={true}
        displayTab={true}
      />
    );
  };

  renderTableHeader = () => {
    const tradeOptions = this.getTradeOptions();
    const assigneeOptions = this.getAssigneeOptions();
    console.log("renderTableHeader", this.state.lotStatus);
    return (
      <div className="table-header">
        <div className="row">
          <div className="col-sm-12">
            <ul className="rfs-detail-table-header punch-list-detail-table-header-list col-sm-9">
              {AppSettings.clientTypeValue === "Builder" && (
                <li
                  className={
                    this.state.headerAction.value !== 0 ? "has-btn-go" : ""
                  }
                >
                  <Dropdown
                    onChange={this.onChangeHeaderAction}
                    filter={true}
                    className="filestring-dropdown filter-dropdown"
                    options={this.state.headerOptions}
                    optionLabel="text"
                    value={this.state.headerAction}
                    style={{ margin: 0, display: "inline-block" }}
                  />
                  {this.state.headerAction.value === 0 && (
                    <button
                      className="btn btn-primary btn-info btn-siteone btn-icon btn-go-mobile"
                      disabled
                      style={{
                        marginBottom: 16,
                        height: 40,
                      }}
                    >
                      Go
                    </button>
                  )}
                  {this.state.headerAction.value === 1 &&
                    Object.keys(this.state.refNoCheckList).length === 0 && (
                      <OverlayTrigger
                        trigger="click"
                        rootClose
                        placement={this.state.isMobile ? "bottom" : "right"}
                        overlay={this.popoverRight()}
                      >
                        <button
                          className="btn btn-primary btn-info btn-siteone btn-icon"
                          style={{
                            marginBottom: 16,
                            height: 40,
                          }}
                        >
                          Go
                        </button>
                      </OverlayTrigger>
                    )}
                  {this.state.headerAction.value === 1 &&
                    Object.keys(this.state.refNoCheckList).length !== 0 && (
                      <button
                        className="btn btn-primary btn-info btn-siteone btn-icon"
                        onClick={this.onClickGoSignoffMultiplePopup}
                        style={{
                          marginBottom: 16,
                          height: 40,
                        }}
                      >
                        Go
                      </button>
                    )}
                  {this.state.headerAction.value === 1 &&
                    this.state.isDisplaySignoffMultiplePopup && (
                      <SignoffMultiplePopup
                        isValid={
                          Object.keys(this.state.refNoCheckList).length !== 0
                        }
                        onSaveSignoffPopup={this.onSaveSignoffMultiple}
                        onCancelSignoffPopup={
                          this.onClickGoSignoffMultiplePopup
                        }
                      />
                    )}

                  {this.state.headerAction.value === 2 &&
                    Object.keys(this.state.refNoSendCheckList).length !== 0 && (
                      <button
                        className="btn btn-primary btn-info btn-siteone btn-icon"
                        onClick={this.onClickGoSendMultiplePopup}
                        style={{
                          marginBottom: 16,
                          height: 40,
                        }}
                      >
                        Go
                      </button>
                    )}
                  {this.state.headerAction.value === 2 &&
                    this.state.isDisplaySendMultiplePopup && (
                      <SendMultipleWorkOrderPopup
                        onSend={this.onSaveSendMultiple}
                        onCancel={this.onClickGoSendMultiplePopup}
                      />
                    )}
                  {this.state.headerAction.value === 2 &&
                    Object.keys(this.state.refNoSendCheckList).length === 0 && (
                      <OverlayTrigger
                        trigger="click"
                        rootClose
                        placement={this.state.isMobile ? "bottom" : "right"}
                        overlay={this.popoverRight()}
                      >
                        <button
                          className="btn btn-primary btn-info btn-siteone btn-icon"
                          style={{
                            marginBottom: 16,
                            height: 40,
                          }}
                        >
                          Go
                        </button>
                      </OverlayTrigger>
                    )}
                </li>
              )}

              <li>
                <p className="filter-label">Filters</p>
                <Dropdown
                  onChange={this.onChangeTradeFilter}
                  filter={true}
                  className="filestring-dropdown filter-dropdown"
                  options={tradeOptions}
                  optionLabel="text"
                  placeholder="Trade"
                  value={this.state.trade}
                  showClear={true}
                  style={{ margin: 0 }}
                />
              </li>

              <React.Fragment>
                {AppSettings.clientTypeValue === "Builder" && (
                  <li>
                    <Dropdown
                      onChange={this.onChangeAssigneeFilter}
                      filter={true}
                      className="filestring-dropdown filter-dropdown"
                      options={assigneeOptions}
                      optionLabel="text"
                      placeholder="Assignee"
                      value={this.state.assignee}
                      showClear={true}
                      style={{ margin: 0 }}
                      disabled={!this.state.lotStatus}
                    />
                  </li>
                )}
                {this.state.lotStatus ? null : (
                  <OverlayTrigger
                    placement="top"
                    overlay={this.toolTip()}
                    delayHide={10}
                    delayShow={500}
                  >
                    <span
                      style={{ paddingRight: 10 }}
                      className="fa fa-info-circle"
                    />
                  </OverlayTrigger>
                )}
              </React.Fragment>
            </ul>
            <div
              className="col-sm-3 punch-list-detail__box-search"
              style={{ margin: 0, transform: "translateY(3px)" }}
            >
              <div className="box-search">
                <div className="input-group">
                  <input
                    type="text"
                    id="txt-search-summary"
                    ref={(ref) => {
                      this.search = ref;
                    }}
                    className="form-control"
                    placeholder="Item summary"
                    onKeyPress={this.onEnter.bind(this)}
                  />
                  <span className="input-group-btn">
                    <button
                      onClick={this.onSearch.bind(this)}
                      className="btn btn-secondary"
                    >
                      <span className="fa fa-search" aria-hidden="true" />
                    </button>
                  </span>
                </div>
              </div>
              <div className="manage-user-filter pull-right">
                <button
                  id="popup-button"
                  onClick={this.onTogglePopupFilter}
                  className="btn btn-secondary fa fa-filter btn-icon"
                />
                {this.state.isShowPopup && (
                  <Popup
                    ref={(ref) => {
                      this.popup = ref;
                    }}
                    styles={{ width: 220, left: -60, zIndex: 99999 }}
                  >
                    {PUNCH_ITEM_STATUS_VALUE.map((item) => {
                      return (
                        <CheckBox
                          checked={this.state.checkedValues.includes(item.key)}
                          name="status"
                          className="punch-item__status"
                          value={item.key}
                          key={item.key}
                          label={item.value}
                          handleChange={this.handleChange}
                        />
                      );
                    })}
                  </Popup>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  checkEPLIsAvailable = (refNo, callback) => {
    this.props.dispatch({
      type: RFSActionType.GET_EPL_IS_AVAILABLE_ASYNC,
      params: {
        refNo: refNo,
      },
      callback,
    });
  };

  onEPLClick = () => {
    this.checkEPLIsAvailable(this.state.punchListRefNo, (data) => {
      if (data === true) {
        this.props.history.push(
          `/punch-lists/electronic-punch-list/${this.state.punchListRefNo}`,
        );
      } else {
        this.setState({ openAlertModal: true });
      }
    });
  };

  onCancelAlert = () => {
    this.setState({ openAlertModal: false });
  };

  onGoToTemplates = () => {
    this.props.history.push(
      `/projects/edit/${this.props.PunchListProfile.project.id}?categoryId&inventoryId&projectTab=project-template`,
    );
  };

  toolTipEPL() {
    return (
      <Tooltip className="in tooltip-siteone" id="disable-go-to">
        <span>Electronic Punch List</span>
      </Tooltip>
    );
  }

  render() {
    const { PunchListProfile } = this.props;
    if (PunchListProfile) {
      const totalRecord = PunchListProfile.workOrders
        ? PunchListProfile.workOrders.totalRecord
        : 0;

      const options = {
        defaultSortName: this.state.defaultSortName, // default sort column name
        defaultSortOrder: this.state.defaultSortOrder, // default sort order,
        sizePerPage: this.state.sizePerPage,
        totalRecord: totalRecord,
      };

      return (
        <div className="rfs-detail">
          <div className="page-title clearfix">
            <h2 className="pull-left">
              {AppSettings.clientTypeValue === "Builder" ? "BT #" : "PL #"}
              {this.state.punchListRefNo}
            </h2>
          </div>
          <ul className="breadcrumb">
            <li>
              <Link to={"/punch-lists"}>
                {AppSettings.clientTypeValue === "Builder"
                  ? "Blue Tape"
                  : // <Translate translateKey='punchlist' capitalize />
                    "Punch list"}
              </Link>
            </li>
            <li className="breadcrumb-siteone-li">
              {AppSettings.clientTypeValue === "Builder" ? "BT #" : "PL #"}
              {this.state.punchListRefNo}
            </li>
          </ul>
          <div className="wrapper" style={{ minHeight: "auto" }}>
            {PunchListProfile &&
              PunchListProfile.project &&
              this.renderPunchListInfo()}
          </div>

          <div className="page-title clearfix" style={{ marginTop: 40 }}>
            <h3 className="pull-left" style={{ margin: 0 }}>
              Work orders ({this.state.data.length})
            </h3>
            {AppSettings.clientTypeValue !== "Homeowner" &&
              AppSettings.clientTypeValue !== "Subcontractor" && (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      display: "inline-flex",
                    }}
                  >
                    <button
                      className="btn btn-siteone pull-right btn-icon"
                      style={{ marginTop: 2, margin: 0 }}
                      onClick={this.onClickOnEmailButton}
                    >
                      <span className="fa fa-envelope icon" />
                      EMAIL
                    </button>
                    {this.state.showEmailInputBox && (
                      <Popup
                        className="reopen-popup"
                        isHasFaded={true}
                        styles={{
                          width: 370,
                          minHeight: 200,
                          top: 34,
                          right: 0,
                          left: "auto",
                          marginLeft: 0,
                          zIndex: 999,
                        }}
                      >
                        <div className="recipients-email-eoc container-fluid">
                          <label>
                            Recipients <span className="text-danger">*</span>
                          </label>
                          <button
                            type="button"
                            className="close"
                            onClick={this.onCloseEmailBox}
                          >
                            &times;
                          </button>
                          <TagsInput
                            value={this.state.recipientEmail}
                            onChange={this.handleEmailChange}
                            inputProps={this.state.inputProps}
                            addKeys={[9, 13, 188]}
                            addOnBlur
                            autoFocus
                            suggestions={this.state.emailSuggestions}
                            autocomplete={true}
                            onlyUnique={true}
                          />
                          <button
                            disabled={this.state.recipientEmail.length === 0}
                            onClick={this.onClickSendInEmailBox}
                            style={{ float: "left", marginTop: 7, margin: 0 }}
                            className="btn btn-primary btn-siteone"
                          >
                            Send
                          </button>
                        </div>
                      </Popup>
                    )}
                  </div>
                  <button
                    className="btn btn-siteone pull-right btn-icon"
                    style={{ marginTop: 2, margin: 0 }}
                    onClick={this.onPrintReport}
                  >
                    <span className="fa fa-download icon" />
                    PRINT
                  </button>
                  <button
                    className="btn btn-siteone pull-right btn-icon"
                    onClick={this.onNewWorkOrder}
                    disabled={PunchListProfile.status === 3}
                    style={{ marginTop: 2, margin: 0 }}
                  >
                    <span className="fa fa-plus icon" />
                    NEW
                  </button>
                  {
                    <OverlayTrigger
                      placement="bottom"
                      overlay={this.toolTipEPL()}
                      delayHide={10}
                      delayShow={500}
                    >
                      <button
                        style={{ width: 100, marginTop: 2, margin: 0 }}
                        className="btn btn-siteone btn-siteone-orange pull-right"
                        onClick={this.onEPLClick}
                      >
                        EPL
                      </button>
                    </OverlayTrigger>
                  }
                </div>
              )}
          </div>

          <TableList
            column={this.state.column}
            defaultParams={defaultParams}
            pagination={false}
            data={this.state.data}
            options={options}
            refreshPageList={this.refreshList.bind(this)}
            refreshList={this.refreshList.bind(this)}
            trClassName={(row) => checkIsOverdueWorkOrder(row)}
            customTableHeader={this.renderTableHeader()}
            // showButtonMenu={true}
            //onContextMenu={this.onContextMenu.bind(this)}
          />
          <AlertRequestTypeNotAvailable
            isOpen={this.state.openAlertModal}
            onCancel={this.onCancelAlert}
            onGoToTemplates={this.onGoToTemplates}
            requestTypeName={
              (this.props.PunchListProfile.requestType &&
                this.props.PunchListProfile.requestType.name) ||
              ""
            }
          />
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    UserProfile: state.UserStore,
    PunchListProfile: state.PunchListStore.PunchListProfile,
  };
};

export default connect(mapStateToProps)(ManagePunchListItems);



// WEBPACK FOOTER //
// ./src/Punch-List/Containers/manage-punch-list-items.js